import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

function ExportModalFooter({ isFormAcceptable, apply }) {
  return (
    <div className="exportModal__footer">
      <ButtonWithIcon
        type="primary"
        size="small"
        sprite="ChevronRight"
        linkIconSize="s"
        iconRight
        onClick={apply}
        disabled={!isFormAcceptable}
        className="e2e-export-modal-apply">
        Export
      </ButtonWithIcon>
    </div>
  );
}

ExportModalFooter.propTypes = {
  isFormAcceptable: PropTypes.bool,
  apply: PropTypes.func.isRequired,
};

export default ExportModalFooter;
